import { Col, Row, Spinner } from "react-bootstrap";
import { useContext, useState } from "react";
import dayjs from "dayjs";
import { closeEnquiry } from "../../../../api/itinerary.api";
import { SelectedUserContext } from "../../../../context/selecteduser.context";
import { CalendarIconSvg, MoonIconSvg, ShipIconSvg } from "../../../../assets/svg";
import { useNavigate } from "react-router-dom";
import SnackbarContext from "../../../../context/snackbar.context";
import { splitDate } from "../../../../utils/splitDate";

const CustomerEnquiry = ({ customerEnquirydata, setCustomerEnquiryData, setStepNumber }: any) => {
  const navigate = useNavigate();
  const snackbarCtx = useContext(SnackbarContext);
  const [loading,setLoading]=useState(false)
  const { selectedUser, handleExistingEnquiry } = useContext(SelectedUserContext);

  const handleTripType = (tripType: string) => {
    return tripType?.includes('one') ? 'One Way Trip' : 'Round Trip';
  }

  return (
    <div className="mb-4 mt-12 border rounded bg-light p-2 pb-3">
      <p className="ml-3 mt-2" style={{ fontSize: "22px", fontWeight: "700", lineHeight: "28.64px", color: "#3A3A3A" }}>
        Existing Customer Enquiry
      </p>
      <Row className="m-0 my-4 text-[#7A7A7A] text-[17px] font-medium">
        <Col className="flex items-center text-nowrap">
          <CalendarIconSvg width={22} height={22} fill="#7A7A7A" />
          {!!customerEnquirydata?.enquiryPref?.startDate ? <p className="mx-1 my-auto">
            {dayjs(splitDate(customerEnquirydata?.enquiryPref?.startDate)).format("DD MMM YYYY")} -{" "}
            {dayjs(splitDate(customerEnquirydata?.enquiryPref?.endDate)).format("DD MMM YYYY")}
          </p> : <p className="mx-1 my-auto">No Date Range Selected</p>}
        </Col>
          <Col className="flex items-center">
            <p className="mx-1 my-auto">Depature: {customerEnquirydata?.enquiryPref?.departure?.name || 'NA'}</p>
          </Col>
          <Col className="flex items-center">
            <p className="mx-1 my-auto">Destination: {customerEnquirydata?.enquiryPref?.destination?.name || 'NA'}</p>
          </Col>
          <Col className="flex items-center">
            <p className="mx-1 my-auto">Trip Type: {!!customerEnquirydata?.enquiryPref?.tripType ? handleTripType(customerEnquirydata?.enquiryPref?.tripType) : 'NA'}</p>
          </Col>
      </Row>
        <Row className=" m-0 my-4 text-[#7A7A7A] text-[17px] font-medium">
          <Col xs={3} className="flex items-center">
            <ShipIconSvg fill="#7a7a7a" height={20} width={18} />
            <span className="mx-1 my-auto">Cruise: {customerEnquirydata?.enquiryPref?.shipName || 'NA'}</span>
          </Col>
          <Col className="flex gap-2 items-center">
            <MoonIconSvg fill="#7a7a7a" height={18} width={18} />
            <span>Nights:</span>
            {!!customerEnquirydata?.enquiryPref?.nightCount?.length ? customerEnquirydata?.enquiryPref?.nightCount?.map((night: string) => (
              <div className="w-[30px] h-[30px] bg-[#D0566E] flex items-center justify-center rounded">
                <span className="text-[#fff]" key={night}>
                  {night}
                </span>
              </div>
            )): <p className="mx-1 my-auto">NA</p>}
          </Col>
        </Row>
      <div
        className="text-[#3A3A3A] mx-0 flex justify-content-end"
        style={{ fontSize: "16px", lineHeight: "20.83px", fontWeight: "400" }}
      >
          <button
            className="btn btn-secondary px-3 mx-3 max-w-[160px]"
            onClick={() => {
              navigate(`/add-leads/2/${selectedUser?.id}`);
              setStepNumber(2);
            }}
          >
            Search Itinerary
          </button>
          <button
            className="btn text-light px-3 mx-3 max-w-[160px]"
            style={{ background: "linear-gradient(305.75deg, #92278F -144.06%, #EC7765 147.18%)" }}
            onClick={async () => {
              setLoading(true);
              const data = await closeEnquiry(customerEnquirydata?.id);
              if (data?.status === 200) {
                snackbarCtx.toggleSnackbar({
                  message: "Enquiry has been closed !",
                  type: "SUCCESS",
                  visible: true,
                });
                setCustomerEnquiryData({});
                handleExistingEnquiry({});
              }
              setLoading(false);
              navigate(`/add-leads/2/${selectedUser?.id}`);
              setStepNumber(2);
            }}
          >
            {loading && <Spinner animation="border" size="sm" className="mr-3" />}
            Close Enquiry
          </button>
      </div>
    </div>
  );
};

export default CustomerEnquiry;